<template>
  <div :class="$style.price">{{ priceFormatted }}</div>
</template>

<script>
export default {
  name: 'BasketProductPrice',
  props: {
    price: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
      default: 'EUR',
    },
  },
  computed: {
    priceFormatted() {
      return this.price ? this.$n(this.price, { key: 'currency', currency: this.currency }) : '-'
    },
  },
}
</script>

<style lang="scss" module>
.price {
  color: #99a9af;
  font-family: var(--font-mono);
  line-height: normal;
  text-align: right;
}
</style>
